import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function Community() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section id="comunidad" ref={ref} className="relative py-32 px-6 bg-dark-800">
      <div className="max-w-5xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="flex items-center justify-center gap-4 mb-8">
            <i className="ri-whatsapp-line text-6xl text-gold-400"></i>
            <h2 className="font-serif text-5xl md:text-6xl text-gold-400">
              Comunidad
            </h2>
          </div>

          <h3 className="font-serif text-3xl text-warm-100 mb-8">
            Comunidad General de WhatsApp
          </h3>

          <div className="max-w-3xl mx-auto space-y-8 mb-12">
            <p className="font-sans text-xl text-warm-200 leading-relaxed">
              Únete a nuestra comunidad oficial y camina acompañado en esta peregrinación interior. Al Registrarte tendrás acceso al Chat de Estudio.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-dark-900 border border-gold-500/20 rounded-lg p-6">
                <i className="ri-message-3-line text-4xl text-gold-400 mb-4"></i>
                <h4 className="font-sans text-lg text-warm-100 font-semibold mb-2">
                  Acompañamiento diario
                </h4>
                <p className="font-sans text-warm-200">
                  Recibe mensajes de inspiración y guía cada día
                </p>
              </div>

              <div className="bg-dark-900 border border-gold-500/20 rounded-lg p-6">
                <i className="ri-notification-3-line text-4xl text-gold-400 mb-4"></i>
                <h4 className="font-sans text-lg text-warm-100 font-semibold mb-2">
                  Avisos importantes
                </h4>
                <p className="font-sans text-warm-200">
                  Mantente informado sobre encuentros y eventos
                </p>
              </div>

              <div className="bg-dark-900 border border-gold-500/20 rounded-lg p-6">
                <i className="ri-article-line text-4xl text-gold-400 mb-4"></i>
                <h4 className="font-sans text-lg text-warm-100 font-semibold mb-2">
                  Contenido espiritual
                </h4>
                <p className="font-sans text-warm-200">
                  Reflexiones, oraciones y recursos exclusivos
                </p>
              </div>

              <div className="bg-dark-900 border border-gold-500/20 rounded-lg p-6">
                <i className="ri-team-line text-4xl text-gold-400 mb-4"></i>
                <h4 className="font-sans text-lg text-warm-100 font-semibold mb-2">
                  Comunidad activa
                </h4>
                <p className="font-sans text-warm-200">
                  Comparte tu experiencia con otros peregrinos
                </p>
              </div>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={inView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <a
              href="https://chat.whatsapp.com/Dp55j3JPXRJ7rwbHSHjHIm"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-3 px-12 py-6 bg-[#25D366] text-white font-sans font-semibold text-xl rounded-lg hover:bg-[#20BA5A] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              <i className="ri-whatsapp-line text-3xl"></i>
              Unirme a la Comunidad
              <i className="ri-arrow-right-line text-2xl"></i>
            </a>
          </motion.div>
        </motion.div>
      </div>

      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 rounded-full blur-3xl -z-10"></div>
    </section>
  );
}